var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vote-container"},[_c('div',{staticClass:"vote-button noselect",on:{"click":function () {
        _vm.createVoteVisible = true;
      }}},[_c('h2',[_vm._v("Vote")])]),_c('vote-dialog',{attrs:{"visible":_vm.createVoteVisible,"roomId":_vm.roomId,"room":_vm.room,"userId":_vm.userId,"user":_vm.user},on:{"close":function () {
        _vm.createVoteVisible = false;
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }